import script from "./BestellenIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./BestellenIndex.vue?vue&type=script&setup=true&lang=js"

import "./BestellenIndex.vue?vue&type=style&index=0&id=66259292&scoped=true&lang=css"
/* custom blocks */
import block0 from "./BestellenIndex.vue?vue&type=custom&index=0&blockType=div&style=position%3A%20fixed%3B%20top%3A%2050%25%3B%20left%3A%200%3B%20right%3A%200%3B%20transform%3A%20translateY(-50%25)%3B%20z-index%3A%201000%3B"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66259292"]])

export default __exports__